import {UseForm} from "@mantine/hooks/lib/use-form/use-form";
import {TextInput} from "@mantine/core";
import MantineSelect from "../../../Mantine.select";
import {UseFormReturnType} from "@mantine/form/lib/use-form";

export default function Indonesia(form: UseFormReturnType<any>, disableAllFields = false) {
    return {
        display: "Indonesia",
        formItems: [
            <TextInput
                disabled={disableAllFields}
                required
                placeholder="Address"
                label="Address"
                {...form.getInputProps("address1")}/>,
            <TextInput
                disabled={disableAllFields}
                placeholder="Apartment, suite, etc."
                label="Apartment, suite, etc."
                {...form.getInputProps("address2")}/>,
            <TextInput
                disabled={disableAllFields}
                required
                placeholder="City"
                label="City"
                {...form.getInputProps("city")}/>,
            <TextInput
                disabled={disableAllFields}
                required
                placeholder="Postal Code"
                label="Postal Code"
                {...form.getInputProps("postalCode")}/>
        ]
    }
}